import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';
import { DialogService } from '../shared/dialog/dialog.service';
import { DialogRememberPwdComponent } from '../shared/dialog/dialog-rememberpwd.component';
import { ActionLoaderComponent } from '../shared/action-loader/action-loader.component';
import { AuthObservabilityService } from '../shared/monitoring/auth-observability.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  @ViewChild('loginLoader')
  public loginLoader: ActionLoaderComponent;

  msg = '';

  constructor(
    private service: LoginService,
    private routes: Router,
    private dialog: DialogService,
    private authObservability: AuthObservabilityService
  ) {}

  ngOnInit(): void {}

  check(uname: string, p: string) {
    this.loginLoader.start();
    this.msg = '';

    this.service
      .login(uname, p)
      .then(() => {
        this.authObservability.trackLoginSucceeded();
        this.routes.navigate(['/panel']);
      })
      .catch((res) => {
        this.msg = 'Invalid Username or Password';
        this.authObservability.trackLoginFailed({ errorCode: res?.code || 'unknown' });
      })
      .finally(() => {
        this.loginLoader.stop();
      });
  }

  onRememberPwd() {
    this.dialog.host.open(DialogRememberPwdComponent, {
      disableClose: true,
      width: '500px',
    });
  }
}
